module.exports = __webpack_public_path__ + "img/sampleGraph8.b6baf6a0.png";